export default __webpack_public_path__ + "static/media/calculator-alt.b41cadf0.svg";